import React from "react";
import { NavLink } from "react-router-dom";
import LogoLinkedin from "../../assets/logos/logo-linkedin.svg";

export default function HomeHero() {
  const cardCompanies = [
    {
      logo: require("../../assets/logos/logo-forager-media-group.png"),
      style: "w-44 2xl:w-full 2xl:px-32 2xl:py-12 hover:scale-110 with-transition",
    },
    {
      logo: require("../../assets/logos/logo-forager-education.png"),
      style: "w-40 2xl:w-full 2xl:px-32 2xl:py-11 hover:scale-110 with-transition",
    },
    {
      logo: require("../../assets/logos/logo-forager-financial.png"),
      style: "w-60 2xl:w-full md:px-2 2xl:px-24 2xl:py-11 hover:scale-110 with-transition",
    },
  ];

  return (
    <section>
      <div className="bg-dark-denim">
        <div className="px-4 app-home-hero relative overflow-hidden bg-cover bg-no-repeat with-curved-bottom">
        <div className="container mx-auto pb-52 lg:pb-32 text-white">
          <div className="md:hidden">
            <img
              src={require("../../assets/img/home/mobile/planet-1.png")}
              alt=""
              className="absolute left-6 top-16 w-24"
            />
            <img
              src={require("../../assets/img/home/mobile/circle-1.png")}
              alt=""
              className="absolute right-0 top-0 w-32 -translate-y-5"
            />
            <img
              src={require("../../assets/img/home/mobile/planet-rocket.png")}
              alt=""
              className="absolute -bottom-64 right-0 w-64"
            />
          </div>
          <div className="hidden md:block">
            <img
              src={require("../../assets/img/home/desktop/planet-1.png")}
              alt=""
              className="absolute -left-10 -top-[87%] xl:-top-[73%] w-[52rem]"
            />
            <img
              src={require("../../assets/img/home/desktop/planet-2.png")}
              alt=""
              className="absolute left-1/2 -translate-x-1/2 top-24 w-20"
            />
            <img
              src={require("../../assets/img/home/desktop/circle-1.png")}
              alt=""
              className="absolute -right-80 -translate-x-1/2 -top-80 w-[32rem]"
            />
            <img
              src={require("../../assets/img/home/desktop/planet-rocket.png")}
              alt=""
              className="absolute -bottom-96 xl:-bottom-80 -right-52 xl:-right-32 w-[48rem]"
            />
          </div>
          <div className="w-fit">
            <div className="max-w-lg lg:max-w-[52.5rem] flex flex-col lg:items-start mt-6">
              <h1 className="mt-40 lg:text-2xl mb-3.5 font-medium with-line-above before:w-10 lg:line-above-start">
                forager international
              </h1>
              <h2 className="text-4xl md:text-6xl leading-[3.1rem] md:leading-[4.36rem] mb-8 lg:mb-11">
                a network of businesses innovating solutions for heritage
              </h2>
              <NavLink
                to="/about"
                className="w-40 h-12 mb-32 lg:mb-16 font-medium bg-white hover:bg-dark-denim hover:text-white rounded-full text-dark-denim grid place-items-center with-transition"
              >
                learn more
              </NavLink>
            </div>
            <a
              href="follow"
              className="with-line-above flex"
              target="_blank"
            >
              follow us
              <img
                src={LogoLinkedin}
                alt="linkedin logo"
                className="ml-2 w-7 h-7"
              />
            </a>
          </div>
        </div>
      </div>
      </div>
      <div className="bg-dark-denim">
        <div className="container mx-auto pt-20 lg:pt-16 pb-52 md:pb-40">
          <p className="max-w-4xl mx-auto mb-20 lg:mb-16 px-4 text-white md:text-center">
            Forager International was founded on the principles of collaboration
            and innovation. We have a mission to develop innovative solutions to
            challenges faced by the heritage sector. Creating relationships with
            institutions and associations, our goal is to understand the unique
            needs of this underserved community and work with partners around
            the world to build capacity for the sector as a whole, preserving
            and promoting natural and cultural heritage.
          </p>
          <h2 className="pt-2 mb-16 lg:mb-11 text-white text-4xl lg:text-5xl text-center with-line-above line-above-center before:w-36">
            a growing network
          </h2>
          <div className="justify-center px-4 grid grid-cols-3 gap-5">
            {cardCompanies.map((e, i) => (
              <NavLink to="/companies" key={i} className="col-span-3 md:col-span-1">
                <div className="h-40 rounded-xl bg-white grid place-items-center">
                  <img src={e.logo} alt="" className={e.style} />
                </div>
              </NavLink>
            ))}
          </div>

          <NavLink
            to="/companies"
            className="mx-auto mt-14 font-semibold h-12 w-80 bg-white rounded-full text-dark-denim hover:bg-navy-blue hover:text-white grid place-items-center with-transition"
          >
            our business portfolio
          </NavLink>
        </div>
      </div>
    </section>
  );
}
